var App = App || {};

App.SubpageDynamicLinks = (function ($) {
    "use strict";

    function init() {
        const SubpageDynamicLinksBlock = $(".block.block-subpage-dynamiclinks");
        const inactiveClass = "hidden";

        if (SubpageDynamicLinksBlock.length) {
            SubpageDynamicLinksBlock.each(function () {
                var thisBand = $(this);
                var expandAllBtn = thisBand.find(".btn.expand-all");
                var collapseAllBtn = thisBand.find(".btn.collapse-all");
                var defaultHiddenSection = thisBand.find(".dynamiclinks-links-list.default-hidden");
                var showMoreBtns = thisBand.find(".btn.group-toggle.show-more");
                var showLessBtns = thisBand.find(".btn.group-toggle.show-less");
                var linkGroups = thisBand.find(".dynamiclinks-group");

                expandAllBtn.on("click", function () {
                    //show
                    defaultHiddenSection.removeClass(inactiveClass);
                    showLessBtns.removeClass(inactiveClass);
                    collapseAllBtn.removeClass(inactiveClass);
                    //hide
                    showMoreBtns.addClass(inactiveClass);
                    expandAllBtn.addClass(inactiveClass);
                });

                collapseAllBtn.on("click", function () {
                    //hide
                    defaultHiddenSection.addClass(inactiveClass);
                    showLessBtns.addClass(inactiveClass);
                    collapseAllBtn.addClass(inactiveClass);
                    //show
                    showMoreBtns.removeClass(inactiveClass);
                    expandAllBtn.removeClass(inactiveClass);
                });

                //independent expand & collapse controls for each group section
                linkGroups.each(function () {
                    var thisGroup = $(this);
                    var showMoreBtn = thisGroup.find(".btn.show-more");
                    var showLessBtn = thisGroup.find(".btn.show-less");

                    showMoreBtn.on("click", function () {
                        var clickedId = $(this).attr("aria-controls");
                        $("#" + clickedId).removeClass(inactiveClass);
                        showLessBtn.removeClass(inactiveClass);
                        showMoreBtn.addClass(inactiveClass);
                    });

                    showLessBtn.on("click", function () {
                        var clickedId = $(this).attr("aria-controls");
                        $("#" + clickedId).addClass(inactiveClass);
                        showLessBtn.addClass(inactiveClass);
                        showMoreBtn.removeClass(inactiveClass);
                    });
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SubpageDynamicLinks.init();
});